import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './NoActivitiesStyles';

export default class NoActivities extends Component {
  render() {
    return (
        <div className={css(styles.endWrapper)}>
          <span className={css(styles.rightSide)}>{`~ No activities to show ~`}</span>
        </div>
    );
  }
}
